import React from 'react'

import { withStyles } from 'pmt-ui/styles'
import Typography from 'pmt-ui/Typography'

import Resizer from './Resizer'

const styles = theme => ({
  component: {
    width: '100%',
    marginBottom: theme.spacing(4),
  },
  title: {
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
})

class ComponentList extends React.Component {
  generateComponent(componentList) {
    const { classes } = this.props

    return componentList.map((component, index) => (
      <div key={index} className={classes.component}>
        <Typography variant="subtitle1" className={classes.title}>
          {component.name}
          <Typography variant="caption">{component.definition}</Typography>
        </Typography>
        {component.resizer ? (
          <Resizer selectedType={'DESKTOP'}>{component.render}</Resizer>
        ) : (
          <div>{component.render}</div>
        )}
      </div>
    ))
  }

  render() {
    const { list, classes } = this.props

    return <div className={classes.componentList}>{this.generateComponent(list)}</div>
  }
}

export default withStyles(styles)(ComponentList)
